import { Modal, Button } from "react-bootstrap";

 const CustomModal = ({ show, title, message, onConfirm, onCancel }) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal"
    >
      <Modal.Header className="d-flex justify-content-center">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex justify-content-center">
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center gap-4">
        <Button variant="outline-secondary" onClick={onCancel}>
          No
        </Button>
        <Button className="btn-outline-custom" onClick={onConfirm}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
